/* =============================================
   PFOTENGLÜCK™ THEME - MAIN JAVASCRIPT
   ============================================= */

'use strict';

// =====================
// CART FUNCTIONALITY
// =====================
document.addEventListener('DOMContentLoaded', function () {

  // Add to Cart
  var form = document.getElementById('product-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(form);
    });
  }

  function addToCart(form) {
    var btn = form.querySelector('[name="add"]');
    if (!btn) return;

    var originalText = btn.innerHTML;
    btn.innerHTML = '⏳ Wird hinzugefügt...';
    btn.disabled = true;

    var formData = new FormData(form);
    var variantId = formData.get('id');

    if (!variantId) {
      btn.innerHTML = originalText;
      btn.disabled = false;
      return;
    }

    fetch(window.theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        btn.innerHTML = '✓ Im Warenkorb!';
        showCartNotification();
        updateCartCount();
        setTimeout(function () {
          btn.innerHTML = originalText;
          btn.disabled = false;
        }, 2500);
      })
      .catch(function (err) {
        console.error('Cart error:', err);
        btn.innerHTML = originalText;
        btn.disabled = false;
      });
  }

  function showCartNotification() {
    var notif = document.getElementById('cartNotification');
    if (!notif) return;
    notif.classList.add('show');
    setTimeout(function () { notif.classList.remove('show'); }, 4000);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var countEl = document.getElementById('cartCount');
        if (countEl) countEl.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  // =====================
  // STICKY CTA BEHAVIOR
  // =====================
  var heroCta = document.getElementById('add-to-cart-main');
  var stickyCta = document.getElementById('stickyCta');

  if (heroCta && stickyCta) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyCta.style.opacity = '0';
          stickyCta.style.pointerEvents = 'none';
        } else {
          stickyCta.style.opacity = '1';
          stickyCta.style.pointerEvents = 'auto';
        }
      });
    }, { threshold: 0.1 });

    observer.observe(heroCta);
    stickyCta.style.transition = 'opacity 0.3s ease';
  }

  // =====================
  // SMOOTH SCROLL
  // =====================
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        var headerHeight = document.getElementById('siteHeader') ? document.getElementById('siteHeader').offsetHeight : 80;
        var y = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    });
  });

  // =====================
  // HEADER SCROLL EFFECT
  // =====================
  var header = document.getElementById('siteHeader');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 80) {
        header.style.boxShadow = '0 4px 24px rgba(0,0,0,0.08)';
      } else {
        header.style.boxShadow = 'none';
      }
    }, { passive: true });
  }

  // =====================
  // SCROLL REVEAL ANIMATIONS
  // =====================
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    var revealElements = document.querySelectorAll('.benefit-card, .review-card, .comparison-card, .faq-item');
    revealElements.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      revealObserver.observe(el);
    });
  }

  // =====================
  // SCARCITY BAR ANIMATION
  // =====================
  var scarcityFill = document.querySelector('.scarcity-bar__fill');
  if (scarcityFill) {
    setTimeout(function () {
      scarcityFill.style.transition = 'width 1.5s ease';
    }, 500);
  }

  // =====================
  // VARIANT IMAGE SWAPPING
  // =====================
  window.changeMainImage = function (thumb) {
    var mainImg = document.getElementById('mainProductImg');
    if (mainImg && thumb.dataset.src) {
      mainImg.style.opacity = '0';
      mainImg.style.transition = 'opacity 0.2s ease';
      setTimeout(function () {
        mainImg.src = thumb.dataset.src;
        mainImg.style.opacity = '1';
      }, 200);
    }
    document.querySelectorAll('.product-gallery__thumb').forEach(function (t) {
      t.classList.remove('active');
    });
    thumb.classList.add('active');
  };

  // =====================
  // LIVE VIEWER COUNT SIMULATION
  // =====================
  function updateViewerCount() {
    var scarcityText = document.querySelector('.scarcity-bar__text span');
    if (!scarcityText) return;
    var base = 23;
    var variation = Math.floor(Math.random() * 7) - 3;
    var count = Math.max(15, base + variation);
    scarcityText.textContent = 'Heute schon ' + count + ' Mal angesehen';
  }
  setInterval(updateViewerCount, 30000);

  // =====================
  // MOBILE MENU
  // =====================
  var menuToggle = document.getElementById('mobileMenuToggle');
  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      var nav = document.querySelector('.site-header__nav');
      if (nav) {
        nav.classList.toggle('open');
      }
    });
  }

  console.log('🐾 Pfotenglück™ Theme loaded. Built for conversion. ❤️');
});
